import React, { FC, useMemo, useState } from 'react'

import { ControllerContext } from './Context/ControllerContext'

const SliderController: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [isDragDisabled, disableDrag] = useState(false)
  const [isZoomedIn, setZoomedIn] = useState(false)

  const value = useMemo(
    () => ({
      disableDrag,
      isDragDisabled,
      setZoomedIn,
      isZoomedIn,
    }),
    [isDragDisabled, isZoomedIn],
  )

  return (
    <ControllerContext.Provider value={value}>
      {children}
    </ControllerContext.Provider>
  )
}

export default SliderController
